import { Component, Input } from '@angular/core';
import { FormGroup } from '@angular/forms';

@Component({
    selector: 'app-multiselect',
    template: `
      <div [formGroup]="form">
        <!-- <select multiple class="form-select" [id]="field.name" [formControlName]="field.formControlName" >
          <option *ngFor="let opt of field.fieldDataSource" [value]="opt.id">{{opt.value}}</option>
        </select> -->

        <!-- <ng-select
          [items]="field.fieldDataSource"
          bindLabel="value"
          bindValue="value"
          [multiple]=true
          [closeOnSelect]="false"
          [searchable]="false"
          [placeholder]="field.placeHolder"
          [(ngModel)]="selectedOptions"
          [formControlName]="field.formControlName"
          >
        </ng-select> -->
        
        <div class="mt-2">
          <p class="text-muted">Selected items:</p>
          <ul>
            <li *ngFor="let opt of selectedOptions">{{opt}}</li>
          </ul>
        </div>
      </div> 
    `
})
export class MultiSelectComponent {
    @Input() field:any = {};
    @Input() form:FormGroup;

    selectedOptions: any[]

    constructor() {

    }
}